import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { useGetInvoices } from '@/services/hooks';
import React, { useEffect, useState } from 'react';
import useHomeStore from '@/store/home';
import PageLoader from '@/components/shared/page-loader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import { IsUpgData } from '@/lib/helper';

const Invoice = () => {
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc');
  const { setExpiredAt, setInvoice, setRemainInvoice } = useHomeStore();
  const {data, error} = useGetInvoices();
  const [manualLoading, setManualLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  useEffect(() => {
    if(data?.invoiceStatusId === 10 && data?.ipgurl) {
      window.location.assign(data?.ipgurl);
    } else if(data?.invoiceStatusId === 40 || data?.invoiceStatusId === 20) {
      navigate('/receipt');
      setManualLoading(false)
    } else if(data?.invoiceExpireTime) {
      setManualLoading(false)
      setExpiredAt(data?.invoiceExpireTime);
      localStorage.setItem('expiredAt', data?.invoiceExpireTime?.toString());
      setInvoice(data?.amount);
      setRemainInvoice(data?.amount);
    }
  }, [data]);

  useEffect(() => {
    const theError = error as AxiosError
    if(theError?.response?.status === 401 ) {
      window.localStorage.clear();
      navigate(`/login?pgc=${pgc}`);
    }
  }, [error]);
  if(manualLoading) return <PageLoader/>
  if(!data || IsUpgData()) return null
  return (
    <Container center className='w-full flex-col px-3 border-b border-grayLight-50 dark:border-grayDark-750 py-3'>
        <Container center className=' w-full justify-start'>
          <Container center className='ml-3 h-10 w-10 rounded-[7px]'>
            <img src={data?.merchantLogo} className='rounded-full' alt='' />
          </Container>
          <Container className='flex flex-col'>
            <Text className='text-sx text-grayLight-850 dark:text-grayDark-75'>
              {localization.merchant}
            </Text>
            <Text
              className='text-base text-grayLight-1000 dark:text-grayLight-0'
              medium
            >
              {data.merchantBrandName}
            </Text>
          </Container>
        </Container>
    </Container>
  );
}
export default Invoice